import { render, staticRenderFns } from "./PendingBusinessesTable.vue?vue&type=template&id=be4c7bfa&scoped=true&"
import script from "./PendingBusinessesTable.vue?vue&type=script&lang=ts&"
export * from "./PendingBusinessesTable.vue?vue&type=script&lang=ts&"
import style0 from "./PendingBusinessesTable.vue?vue&type=style&index=0&id=be4c7bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4c7bfa",
  null
  
)

export default component.exports